// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__a5vXz","vacancies":"Modal_vacancies__QOCXs"};